import { Card, Tag } from 'antd';
import React from 'react';  
import ButtonLoading from '../ButtonLoading';

const { Meta } = Card;

const SelectPlanButton = ({
  plan,
  handleSelectPlan,
  isHiddenOrCustomPlan
}) => {

  if(isHiddenOrCustomPlan) {
    return (
      <button 
        className={'btn btn-grey'} 
        style={{ flex: 1 }}
        onClick={() => null}
      >
        { plan.planCode !== 'free' ? 'Manage Subscription' : 'Selected' }
      </button>
    )
  }

  if(plan.isCurrent) {
    return (
      <button 
        className={plan.planCode !== 'free' ? 'btn btn-green' : 'btn btn-grey'} 
        style={{ flex: 1 }}
        onClick={() => plan.planCode !== 'free' ? handleSelectPlan(plan) : null}
      >
        { plan.planCode !== 'free' ? 'Manage Subscription' : 'Selected' }
      </button>
    )
  }

  if(plan.isPending) {
    return (
      <button 
        className={'btn btn-warning'} 
        style={{ flex: 1 }}
      >
        Pending
      </button>
    )
  }

  return (
    <button 
      className={'btn btn-primary'}
      style={{ flex: 1 }}
      onClick={() => handleSelectPlan(plan) }
    >
      Select
    </button>
  )
}

const PlanTag = ({ plan }) => {
  
  if(plan.isCurrent) {
    return <Tag> Current Plan </Tag>
  }

  if(plan.isPending) {
    return <Tag> Starting { plan.billing.start ? new Date(plan.billing.start).toLocaleDateString('en-CA') : 'Soon'} </Tag>
  }

  return null
}

const PlanCard = ({ 
  plan,
  handleSelectPlan,
  updateSubscriptionLoading,
  isHiddenOrCustomPlan
}) => {

  const features = [ ...plan.features ];

  return (
    <div className='plan-card-container'>
      <Card 
        title={plan.planName}
        extra={<PlanTag plan={plan} />}
        className='plan-card'>
        <Meta
          description={plan.planDescription}
        />
        <div className='plan-card-cta-section'>
          <h1>${plan.planRate}</h1>
          {
            updateSubscriptionLoading ? <div className="btn btn-primary"><ButtonLoading /></div> : <SelectPlanButton plan={plan} handleSelectPlan={handleSelectPlan} isHiddenOrCustomPlan={isHiddenOrCustomPlan}/>
          }
        </div>
        <div style={{ margin: '20px 0px'}}>
        {
          features.map(item => {
            return (
              <div style={{ 
                display: 'flex', 
                flexDirection: 'row',
                margin: '2px 0px',
              }}>
                <span>{item}</span>
              </div>
            )
          })
        }
        </div>
      </Card>
    </div>
  );
}

export default PlanCard;